<template>
    <div class="index_plugins_list">
        <div class="container1500">
            <div class="title">{{ $t('index.second.title') }}</div>
            <div class="plugins_list">
                <div class="plugin_item">
                    <div class="plugin_title title_left">
                        <div>{{ $t('index.second.leftTitle') }}</div>
                        <div>
                            <img src="@/assets/images/Publishers/Contrimetric_logo.png" alt="">
                        </div>
                    </div>
                    <div class="plugin_content">
                        <ul>
                            <li>{{ $t('index.second.leftContent1') }}</li>
                            <li>{{ $t('index.second.leftContent2') }}</li>
                            <li>{{ $t('index.second.leftContent3') }}</li>
                            <li>{{ $t('index.second.leftContent4') }}</li>
                        </ul>
                    </div>
                    <div class="plugin_apply apply_left" @click="openPage('c')">{{ $t('index.second.btnText') }}</div>
                </div>

                <div class="plugin_item">
                    <SeventhBlock></SeventhBlock>
                </div>
            </div>
        </div>
        <submitForm ref="applyDialog"></submitForm>
    </div>
</template>

<script>
import SeventhBlock from "./seventhBlock.vue"
import submitForm from '@/components/submitForm/submitPersonalForm'

export default {
    components: {
        submitForm,
        SeventhBlock
    },
    name: "secondBlock",
    data() {
        return {};
    },
    methods: {
        openPage(type) {
            if (type === "c") {
                this.$refs.applyDialog.openDialog()
            } else if (type === "t") {
                window.open("https://trendmd.com/");
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.plugin_content {
    ul {
        list-style: outside;
        li {
            font-weight: 500;
            letter-spacing: 1px;
        }
    }
}
</style>
